export default __webpack_public_path__ + "static/about_focus-1cdb0b2f964c15f40aa209bbb647986d.webp";